import React, { ComponentPropsWithoutRef, UIEvent, useState } from 'react'
import { Box } from '@branch-messenger/willow-ui'
import { RouterBackButton } from '@components/Button/RouterBackButton'
import { useStoreState } from '@store/index'

import { FlowCardExit } from '.'
import { StyledFlowCardMain, StyledFlowCardTop } from './styles'

type Props = ComponentPropsWithoutRef<typeof StyledFlowCardMain> & {
  showExit?: boolean
  showBack?: boolean
  handleBack?: () => void
}

export const FlowCardMain: React.FC<Props> = ({
  children,
  showExit = true,
  showBack = true,
  handleBack,
  ...rest
}) => {
  const [scrolled, setScrolled] = useState(false)
  const embedded = useStoreState(state => state.onboarding.embedded)
  const allowExit = useStoreState(state => state.onboarding.allowExit)
  const canShowExit = embedded && allowExit && showExit
  const showCardTop = canShowExit || showBack

  const onScroll = (event: UIEvent<HTMLElement>) => {
    const target = event.target as HTMLElement
    if (target.scrollTop >= 10 && !scrolled) {
      setScrolled(true)
    } else if (target.scrollTop < 10 && scrolled) {
      setScrolled(false)
    }
  }

  return (
    <StyledFlowCardMain {...rest} onScroll={onScroll}>
      <StyledFlowCardTop
        style={{
          opacity: showCardTop ? 1 : 0, // Using opacity to keep height of the top bar
          backgroundColor: scrolled ? 'white' : 'transparent',
          boxShadow: scrolled ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none',
        }}
      >
        <Box $flex={1}>
          {showBack && <RouterBackButton back={handleBack} />}
        </Box>
        <Box $flex={1} $display="flex" $justify="flex-end">
          {canShowExit && <FlowCardExit />}
        </Box>
      </StyledFlowCardTop>

      <Box
        $px={4}
        $flex={1}
        $display="flex"
        $direction="column"
        $gap={6}
        $align="stretch"
        $fullWidth
      >
        {children}
      </Box>
    </StyledFlowCardMain>
  )
}
